/** @format */

const isMobile = window.matchMedia("(max-width: 767px)").matches;

export default isMobile;
